var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-settings-wrapper" }, [
    _vm.editfield_id == 0
      ? _c("div", { staticClass: "options-fileds-section text-center" }, [
          _vm._m(0)
        ])
      : _c("div", { staticClass: "panel-field" }, [
          _c(
            "div",
            {
              staticClass: "panel-field-group panel-header",
              attrs: { name: "slide-fade" }
            },
            [
              _c(
                "h2",
                { staticClass: "group-header", on: { click: _vm.toggleBasic } },
                [
                  _vm._v("Basic Options\n                "),
                  _c("i", {
                    class: [
                      _vm.show_basic_settings
                        ? "el-icon-arrow-up"
                        : "el-icon-arrow-down",
                      "toggle-icon"
                    ]
                  })
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.show_basic_settings
                  ? _c(
                      "div",
                      { staticClass: "group-content" },
                      _vm._l(_vm.basic_settings, function(field, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "field-control-item" },
                          [
                            _c("field_" + field.type, {
                              tag: "component",
                              attrs: { field: field, editfield: _vm.editfield }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "panel-field-group panel-header",
              attrs: { name: "slide-fade" }
            },
            [
              _c(
                "h2",
                {
                  staticClass: "group-header",
                  on: { click: _vm.toggleAdvanced }
                },
                [
                  _vm._v(" Advanced Options\n            "),
                  _c("i", {
                    class: [
                      _vm.show_advanced_settings
                        ? "el-icon-arrow-up"
                        : "el-icon-arrow-down",
                      "toggle-icon"
                    ]
                  })
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.show_advanced_settings
                  ? _c(
                      "div",
                      { staticClass: "group-content" },
                      _vm._l(_vm.advanced_settings, function(field, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "field-control-item" },
                          [
                            _c("field_" + field.type, {
                              tag: "component",
                              attrs: { field: field, editfield: _vm.editfield }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticClass: "loader" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }